// Copy functionality for magic links and other copy-to-clipboard features
function initCopyToClipboard() {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.copy-magic-link-btn');
    if (!button) return;

    event.preventDefault();

    const url = button.dataset.url;
    if (!url) return;

    // Store original state immediately
    const originalInnerHTML = button.innerHTML;
    const originalTitle = button.title;

    try {
      // Try modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        // Fallback for older browsers or non-HTTPS contexts
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          document.execCommand('copy');
        } finally {
          document.body.removeChild(textArea);
        }
      }

      // Visual feedback - temporarily change appearance
      button.innerHTML = '<svg class="h-4 w-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path></svg>';
      button.title = 'Copied!';
      button.classList.remove('bg-white', 'border-gray-300');
      button.classList.add('bg-green-50', 'border-green-300');

      // Reset after 2 seconds
      setTimeout(() => {
        if (button && button.parentNode) {
          button.innerHTML = originalInnerHTML;
          button.title = originalTitle;
          button.classList.remove('bg-green-50', 'border-green-300', 'bg-red-50', 'border-red-300');
          button.classList.add('bg-white', 'border-gray-300');
        }
      }, 2000);

    } catch (error) {
      console.error('Failed to copy to clipboard:', error);

      // Error feedback
      button.innerHTML = '<svg class="h-4 w-4 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>';
      button.title = 'Copy failed';
      button.classList.remove('bg-white', 'border-gray-300');
      button.classList.add('bg-red-50', 'border-red-300');

      // Reset after 2 seconds
      setTimeout(() => {
        if (button && button.parentNode) {
          button.innerHTML = originalInnerHTML;
          button.title = originalTitle;
          button.classList.remove('bg-green-50', 'border-green-300', 'bg-red-50', 'border-red-300');
          button.classList.add('bg-white', 'border-gray-300');
        }
      }, 2000);
    }
  });
}

// Initialize on page load and after Turbo navigation
document.addEventListener('DOMContentLoaded', initCopyToClipboard);
document.addEventListener('turbo:load', initCopyToClipboard);